import { Build, Component, h, Host, Listen, Prop, State } from '@stencil/core';

@Component({
  tag: 'mp-top-logo',
  styleUrl: 'mp-top-logo.scss',
})
export class MpTopLogo {


  @Prop() index!: number;
  @Prop() level!: number;


  @State() data_loaded: boolean = false;

  private data_manager: HTMLMpDataManagerElement;
  private lang: string;
  private translations: any = {};
  private title: string = '';
  private menu: any = null;


  @Listen('mpDataInitialised', {target: 'window'})
  onMpDataInitialised() {
    this.loadData();
  }


  async componentWillLoad() {

    this.data_manager = document.querySelector('mp-data-manager');
    if (this.data_manager) {
      if (await this.data_manager.isInitialised()) this.loadData();
    }
  }


  private async loadData() {

    if (!this.data_manager) this.data_manager = document.querySelector('mp-data-manager');
    this.lang = await this.data_manager.getLanguage();
    this.translations = await this.data_manager.getAllTranslations();
    this.title = await this.data_manager.getTitle();
    this.menu = await this.data_manager.getMenu();

    if (!this.data_loaded) this.data_loaded = true;
  }


  render() {

    if (this.index !== 0 || !Build.isBrowser) return (<Host class="ion-hide-md-down"/>);

    if (!this.data_loaded || this.level == 0) {
      return (
        <Host class="ion-hide-md-down">
          <div class="mp-top-logo">
            <mp-icon-logo label={this.translations.labelMammoLogo || ''}/>
          </div>
          <div class="fs-top">
            <div class="title">{this.title}</div>
            <div class="social">
              {this.menu?.social.map((link: any) => {

                const ICON = link.icon;

                return (
                  <hylo-router-link
                    href={link.url}
                    target="_blank"
                    linkLabel={link.label}
                  >
                    <ICON width="50px" height="50px" />
                  </hylo-router-link>
                )

              })}
            </div>
          </div>
        </Host>
      )
    }

    return (
      <Host class="ion-hide-md-down">
        <div class="mp-top-logo">
          <hylo-router-link href={`/${this.lang}`}>
            <mp-icon-logo label={this.translations.labelMammoLogo || ''}/>
            <hylo-sr-only>{this.translations.labelSwitchToMainPage || ''},</hylo-sr-only>
          </hylo-router-link>
        </div>
        <div class="fs-top">
          <div class="title">{this.title}</div>
          <div class="social">
            {this.menu?.social.map((link: any) => {

              const ICON = link.icon;

              return (
                <hylo-router-link
                  href={link.url}
                  target="_blank"
                  linkLabel={link.label}
                >
                  <ICON width="50px" height="50px" />
                </hylo-router-link>
              )

            })}
          </div>
        </div>
      </Host>
    )
  }
}
